import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import { css } from "styled-components";
import MKTUploadZone from "./MKTUploadZone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { connect } from "react-redux";
import ADIFbtUpload from "./ADIFbtUpload";

const mapStateToProps = (state: ApplicationState) => {
    const pathname = getLocation(state).pathname;
    return {
        pathname,
    };
};

type Props = ReturnType<typeof mapStateToProps> & WidgetProps & HasHistory;

export interface ADIUploadFBTTabsStyles {
    leftTabWrapper?: InjectableCss;
    tabs?: InjectableCss;
    FBTtabTitle?: InjectableCss;
    FBTypographying?: InjectableCss;
    rightTab?: InjectableCss;
    rightTabMKT?: InjectableCss;
    ul?: InjectableCss;
    rightTabHeading?: InjectableCss;
    subHeading?: InjectableCss;
    FbtListItems?: InjectableCss;
    subList?: InjectableCss;
    listingHeading?: InjectableCss;
    MKTListItems?: InjectableCss;
    table?: TypographyProps;
    MKTtabTitle?: TypographyProps;
    highLight?: TypographyProps;
    whiteBack?: TypographyProps;
}
export const adiUploadFBTTabsStyles: ADIUploadFBTTabsStyles = {
    leftTabWrapper: {
        css: css`
            display: flex;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                            padding-left: 0px;
                            padding-top: 20px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )};
            .FBT {
                border-top: 1px solid ${ADIColors.gray15};
            }
        `,
    },
    tabs: {
        css: css`
            display: flex;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                        `,
                        null,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )};
        `,
    },
    table: {
        css: css`
            border-collapse: collapse;
            border: 1px solid ${ADIColors.gray20};
            margin-top: 20px;
            width: 100%;
            .mktTD {
                border-collapse: collapse;
                border: 1px solid ${ADIColors.gray19};
                padding: 8px 15px;
            }
            .mktFirstTD {
                border-collapse: collapse;
                border: 1px solid ${ADIColors.gray19};
                padding: 8px 15px;
                border-top: 0;
            }

            .tHead {
                background-color: ${ADIColors.gray14};
                padding: 8px 15px;
                border-bottom: 0;
                border: 1px solid ${ADIColors.gray19};
            }
        `,
    },
    FBTtabTitle: {
        css: css`
            width: 256px;
            text-align: center;
            border-radius: 7px;
            font-size: 14px;
            font-weight: bold;
            padding: 16px 21px;
            background-color: ${ADIColors.gray14};
            &:hover {
                background-color: ${ADIColors.gray14};
                cursor: pointer;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    whiteBack: {
        css: css`
            padding: 16px 21px;
            width: 256px;
            font-size: 14px;
            text-align: center;
            background-color: ${ADIColors.white};
            &:hover {
                background-color: ${ADIColors.gray14};
                cursor: pointer;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])};
        `,
    },

    ul: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    rightTab: {
        css: css`
            width: 800px;
            margin-left: 50px;
            .heading {
                font-weight: bold;
                padding: 20px 0 20px 0;
                display: inline-block;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 0px;
                            padding-top: 20px;
                            width: auto;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    rightTabMKT: {
        css: css`
            width: 625px;
            margin-left: 50px;
            .heading {
                font-weight: bold;
                padding: 20px 0 20px 0;
                display: inline-block;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 0px;
                            padding-top: 20px;
                            width: auto;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },

    rightTabHeading: {
        css: css`
            padding: 20px 28px;
            font-weight: bold;
            font-size: 14px;
            background-color: ${ADIColors.gray14};
            margin-bottom: 19px;
        `,
    },
    subHeading: {
        css: css`
            padding-left: 40px;
        `,
    },
    highLight: {
        css: css`
            background-color: ${ADIColors.gray14};
        `,
    },

    FbtListItems: {
        css: css`
            color: ${ADIColors.darkBlack2};
            font-size: 18px;
            list-style-type: decimal;
            margin-bottom: 15px;
            .subHeading {
                padding-left: 50px;
            }
        `,
    },
    MKTListItems: {
        css: css`
            color: ${ADIColors.darkBlack2};
            font-size: 18px;
            list-style-type: disc;
            margin-bottom: 15px;
            .subHeading {
                padding-left: 98px;
            }
        `,
    },
    subList: {
        css: css`
            list-style-type: lower-alpha;
            margin-bottom: 15px;
        `,
    },
};
const styles = adiUploadFBTTabsStyles;

const ADIUploadFBT: React.FC<Props> = ({ history, id, pathname }) => {
    const [FBTTitleUrl, setFBTTitleUrl] = useState(false);

    const [updateView, setUpdateView] = useState(false);
    useEffect(() => {
        setFBTTitleUrl(pathname.includes("/MyAccount/FBTUpload"));
        setUpdateView(pathname.includes("/MyAccount/MKTUpload"));
    }, []);
    const FBTButton = () => {
        history.push("/MyAccount/FBTUpload");
    };
    const MKTButton = () => {
        history.push("/MyAccount/MKTUpload");
    };
    return (
        <>
            <StyledWrapper {...styles.leftTabWrapper}>
                <Typography as="ul" {...styles.tabs}>
                    <Typography
                        as="li"
                        className="FBT"
                        {...(FBTTitleUrl ? styles.FBTtabTitle : styles.whiteBack)}
                        onClick={FBTButton}
                    >
                        Frequently Bought Together
                    </Typography>
                    <Typography as="li" {...(updateView ? styles.FBTtabTitle : styles.whiteBack)} onClick={MKTButton}>
                        Marketing Label Upload
                    </Typography>
                </Typography>
                {FBTTitleUrl && (
                    <Typography {...styles.rightTab}>
                        <Typography as="h1" {...styles.rightTabHeading}>
                            Upload File for Frequently Bought Together Product
                        </Typography>
                        <ADIFbtUpload />
                        <Typography as="ol" {...styles.subHeading}>
                            <Typography className="heading">Upload Excel file in Required format:</Typography>

                            <Typography as="li" {...styles.FbtListItems}>
                                File cannot include any blank rows.
                            </Typography>
                            <Typography as="li" {...styles.FbtListItems}>
                                File to include two columns. Column headings are not required.
                                <Typography as="ol" className="subHeading">
                                    <Typography as="li" {...styles.subList}>
                                        ADI Part # of Feature Product.
                                    </Typography>
                                    <Typography as="li" {...styles.subList}>
                                        ADI Part # of Frequently Bought Together Product.
                                    </Typography>
                                    <Typography as="li" {...styles.subList}>
                                        When providing two Frequently Bought Together Products include two separate rows
                                        for each.
                                        <Typography as="p">Example:</Typography>
                                        <Typography as="p"> Z4-0804001 DS-DS160</Typography>
                                        <Typography as="p"> Z4-0804001 Z4-01504001</Typography>
                                    </Typography>
                                    <Typography as="li" {...styles.subList}>
                                        When providing Frequently Bought Together Products only provide a maximum of
                                        two, if you provide more than two the third or subsequent entries will be
                                        ignored.
                                    </Typography>
                                </Typography>
                            </Typography>
                            <Typography as="li" {...styles.FbtListItems}>
                                File upload can also be used to remove Frequently Bought Together Products from the
                                website.
                                <Typography as="ol">
                                    <Typography as="li" {...styles.subList}>
                                        Enter an ADI Part # of a Feature Product.
                                    </Typography>
                                    <Typography as="li" {...styles.subList}>
                                        Do not provide an ADI Part # of Frequently Bought Together Product (i.e. blank
                                        field will remove Frequently Bought Together Product previously uploaded).
                                    </Typography>
                                </Typography>
                            </Typography>
                        </Typography>
                    </Typography>
                )}
                {updateView && (
                    <Typography {...styles.rightTabMKT}>
                        <Typography as="h1" {...styles.rightTabHeading}>
                            Upload File for Product Sale Type
                        </Typography>
                        <MKTUploadZone />
                        <Typography className="heading">Upload Excel file in Required format:</Typography>
                        <Typography as="ul" {...styles.subHeading}>
                            <Typography as="li" {...styles.MKTListItems}>
                                Each site(US/CA/PR) to have its own Sale type file
                            </Typography>
                            <Typography as="li" {...styles.MKTListItems}>
                                Files should be created in excel (xlsx) format
                            </Typography>
                            <Typography as="li" {...styles.MKTListItems}>
                                File should be in the below sample format.
                            </Typography>
                            <Typography as="li" {...styles.MKTListItems}>
                                Dates should be in mm/dd/yyyy format
                            </Typography>
                            <Typography as="li" {...styles.MKTListItems}>
                                This file need to be created manually.
                            </Typography>
                            <Typography as="li" {...styles.MKTListItems}>
                                Name of the file will be “Product_MKT_Label”.xlsx
                            </Typography>
                            <Typography as="li" {...styles.MKTListItems}>
                                File cannot include any blank rows.
                            </Typography>
                        </Typography>
                        <Typography as="table" {...styles.table}>
                            <Typography as="thead" className="tHead">
                                <Typography as="th" className="tHead">
                                    {" "}
                                    Product# (Part#)
                                </Typography>
                                <Typography as="th" className="tHead">
                                    {" "}
                                    Start Date
                                </Typography>
                                <Typography as="th" className="tHead">
                                    {" "}
                                    End Date
                                </Typography>
                                <Typography as="th" className="tHead">
                                    {" "}
                                    Sale Type Indicator
                                </Typography>
                            </Typography>
                            <Typography as="tbody">
                                <Typography as="tr">
                                    <Typography as="td" className="mktFirstTD">
                                        {" "}
                                        UZ-NP712
                                    </Typography>
                                    <Typography as="td" className="mktFirstTD">
                                        {" "}
                                        1/5/2021
                                    </Typography>
                                    <Typography as="td" className="mktFirstTD">
                                        {" "}
                                        1/30/2021
                                    </Typography>
                                    <Typography as="td" className="mktFirstTD">
                                        {" "}
                                        SD
                                    </Typography>
                                </Typography>
                                <Typography as="tr">
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        AX-600ULACMB
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        3/5/2021
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        3/20/2021
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        LT
                                    </Typography>
                                </Typography>
                                <Typography as="tr">
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        AX-600ULACM
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        4/5/2021
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        4/30/2021
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        FS
                                    </Typography>
                                </Typography>
                                <Typography as="tr">
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        7M-CR123A
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        6/5/2021
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        7/5/2021
                                    </Typography>
                                    <Typography as="td" className="mktTD">
                                        {" "}
                                        DD
                                    </Typography>
                                </Typography>{" "}
                            </Typography>
                        </Typography>
                    </Typography>
                )}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(ADIUploadFBT)),
    definition: {
        group: "My Account",
        displayName: "ADI UploadFBT Tabs",
    },
};

export default widgetModule;
